<div class="tracks-container">

  <h3>Library</h3>

  <div class="stats-card">
    <div>
      <div class="counter">{{tracksTotal}}</div>
      <div class="hint">Total tracks </div>

<!--      <div class="infoline">-->
<!--        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">-->
<!--          <path d="M4.49992 16.6667L3.33325 15.5001L12.9999 5.83341H7.49992V4.16675H15.8333V12.5001H14.1666V7.00008L4.49992 16.6667Z" fill="#00FF22"/>-->
<!--        </svg>-->

<!--        28-->

<!--        <span>+2.1 % this week</span>-->
<!--      </div>-->

    </div>
  </div>

  <div class="table-toolbar">

    <app-icon-input [formControl]="searchValue" placeholder="Search by title or artist" style="width: 300px"></app-icon-input>

    <div>
      @if (selection.selected.length > 0) {
        <button matButton="filled" class="warning-button" (click)="bulkDelete()">Delete Selected</button>
      }
      <button matButton="filled" style="margin-left: 25px;" (click)="openUploadDialog()">Upload</button>
    </div>

  </div>

  @if(store.isLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="draggable-table-container">
    <table mat-table #table
     cdkDropList (cdkDropListDropped)="drop($event)"
     cdkDropListData="dataSource"
           [cdkDropListDisabled]="dragDisabled || dragInProcess"
     [dataSource]="dataSource" matSort matSortActive="date" matSortDisableClear matSortDirection="desc" (matSortChange)="sortChange($event)">

      <ng-container matColumnDef="drag">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon class="example-drag-cursor" (mouseenter)="dragDisabled = false;" (mouseout)="dragDisabled = true;">drag_indicator</mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row; let index = index">
          <div class="d-flex align-center gap-10">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row.id) : null"
              [checked]="selection.isSelected(row.id)"
            ></mat-checkbox>
            <mat-icon (click)="play(row)" class="pointer" [class.current-track]="currentTrack && currentTrack.id === row.id" >play_circle</mat-icon>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let row">

          <span>{{row.title}}</span>

        </td>
      </ng-container>

      <ng-container matColumnDef="artists">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Artist </th>
        <td mat-cell *matCellDef="let row">
          {{row.artists}}
        </td>
      </ng-container>

      <ng-container matColumnDef="duration">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Duration </th>
        <td mat-cell *matCellDef="let row"> {{row.duration | secondsToTime}} </td>
      </ng-container>
      <ng-container matColumnDef="download">
        <th mat-header-cell *matHeaderCellDef> Downloads </th>
        <td mat-cell *matCellDef="let row"> {{row.downloadsCount || '0'}} </td>
      </ng-container>

      <ng-container matColumnDef="releaseDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Release Date </th>
        <td mat-cell *matCellDef="let row"> {{row.releaseDate | date:'MM/dd/yyyy' }} </td>
      </ng-container>


      <ng-container matColumnDef="enable">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Enable </th>
        <td mat-cell *matCellDef="let row">
          <mat-slide-toggle [checked]="row.enabled" class="thin-toggle" (change)="changeStatus(row.id, $event.checked)" [hideIcon]="true"></mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
        <td mat-cell *matCellDef="let row">
          <div class="d-flex justify-between align-center gap-10">
            <mat-icon (click)="addToPlaylist(row)" [ngClass]="{'disabled': !isTracksAttributesLoaded(), 'icon-highlight': tracksInPlaylist.has(row.id)}" class="pointer mr-5">format_list_bulleted_add</mat-icon>
            <mat-icon (click)="openManageDialog(row)" [ngClass]="{'disabled': !isTracksAttributesLoaded()}" class="pointer">edit</mat-icon>
          </div>

        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row"></tr>

    </table>
        <app-custom-paginator [total]="tracksTotal" (pageChanged)="changePage($event)"></app-custom-paginator>
  </div>
</div>
